import { useContext, useEffect } from 'react';
import { UNSAFE_DataRouterContext, useBlocker } from 'react-router-dom';

/** Browser unload protection is owned by the draft controller; this guards SPA navigation. */
export function UnsavedChangesGuard(props: {
  dirty: boolean;
  saving: boolean;
  discard(): boolean;
}) {
  const dataRouter = useContext(UNSAFE_DataRouterContext);
  return dataRouter ? <RouteGuard {...props} /> : null;
}
function RouteGuard({
  dirty,
  saving,
  discard,
}: {
  dirty: boolean;
  saving: boolean;
  discard(): boolean;
}) {
  const blocker = useBlocker(dirty || saving);
  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    if (!saving && window.confirm('Discard unsaved changes and leave this page?') && discard())
      blocker.proceed();
    else blocker.reset();
  }, [blocker, saving, discard]);
  return null;
}
